export default "__VITE_ASSET__BIMnCb$B__"